import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import {
  setLoadingRoles,
  setLoadingRole,
  setLoadingRoleCreate,
  setLoadingRoleUpdate,
  setLoadingRoleDelete,
  setErrorLoadingRoles,
  setErrorLoadingRole,
  setErrorCreatingRole,
  setErrorUpdatingRole,
  setErrorDeletingRole,
  setRoles,
  setRole,
  createRoleSuccess,
  updateRoleSuccess,
  deleteRoleSuccess,
  setServerResponseStatus,
} from "../slices/role";
import { getErrorMessage } from "../../utils/errorUtils";

export const getRoles = () => async (dispatch) => {
  dispatch(setLoadingRoles());

  try {
    const { data } = await axiosInstance.get("/roles", {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      dispatch(setRoles(data.data));
    }
  } catch (error) {
    dispatch(setErrorLoadingRoles(getErrorMessage(error)));
  }
};

export const getRoleById = (id) => async (dispatch) => {
  dispatch(setLoadingRole());

  try {
    const { data } = await axiosInstance.get(`/roles/${id}`, {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      dispatch(setRole(data.data));
    }
  } catch (error) {
    dispatch(setErrorLoadingRole(getErrorMessage(error)));
  }
};

export const createRole = (values) => async (dispatch) => {
  dispatch(setLoadingRoleCreate());

  try {
    const createRolePayload = {
      name: values.name.trim(),
      description: values.description.trim(),
    };

    const { data } = await axiosInstance.post("/roles", createRolePayload, {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      toast.success(data.message || "Role created successfully!");
      dispatch(createRoleSuccess(data.data));
      dispatch(
        setServerResponseStatus({
          operation: "create",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const message = getErrorMessage(error);
    toast.error(message);
    dispatch(setErrorCreatingRole(message));
  }
};

export const updateRole =
  ({ id, values }) =>
  async (dispatch) => {
    dispatch(setLoadingRoleUpdate());

    try {
      const updateRolePayload = {
        name: values.name.trim(),
        description: values.description.trim(),
        permissions: values.permissions || [],
      };

      const { data } = await axiosInstance.put(
        `/roles/${id}`,
        updateRolePayload,
        {
          headers: { requiresAuth: true },
        },
      );

      if (data.status === "SUCCESS") {
        toast.success(data.message || "Role updated successfully!");
        dispatch(updateRoleSuccess(data.data));
        dispatch(
          setServerResponseStatus({
            operation: "update",
            status: data.statusCode,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(setErrorUpdatingRole(message));
    }
  };

export const deleteRole = (id) => async (dispatch) => {
  dispatch(setLoadingRoleDelete());

  try {
    const { data } = await axiosInstance.delete(`/roles/${id}`, {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      toast.success(data.message || "Role deleted successfully!");
      dispatch(deleteRoleSuccess(id));
      dispatch(
        setServerResponseStatus({
          operation: "delete",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const message = getErrorMessage(error);
    toast.error(message);
    dispatch(setErrorDeletingRole(message));
  }
};

export const resetRoleServerStatus = () => (dispatch) => {
  dispatch(setServerResponseStatus(null));
};
